import { CeruleanButton, WhiteBlueButton } from 'components/Button'
import styled from 'styled-components'
import { color, screenWidth } from 'utils'

export const Wrapper = styled.div`
  border-radius: 0.5rem;
  padding: 2rem;
  width: 34rem;
  min-height: 2rem;
  background: ${color('dark800')};
  color: ${color('white')};

  @media only screen and (max-width: ${screenWidth('sm')}) {
    width: calc(100% - 4rem);
    min-height: 100vh;
    border-radius: 0;
  }
`

export const Header = styled.header`
  margin-bottom: 2rem;
`

export const Title = styled.h1`
  font-weight: 600;
  font-size: 1.5rem;
  line-height: 135%;
  color: ${color('white')};
  text-align: center;
`

export const SubTitle = styled.p`
  font-weight: 500;
  font-size: 1rem;
  line-height: 150%;
  color: ${color('white')};
  text-align: center;
`

export const Button = styled(CeruleanButton)`
  margin-top: 2rem;
  width: 100%;
`

export const SecondaryButton = styled(WhiteBlueButton)`
  margin-top: 2rem;
  width: 100%;
`
